<template>
    <div class="row">
        <div class="col">
            <div class="d-flex justify-content-between align-items-start flex-wrap gap-2">
                <!-- Search input component -->
                <input-search @getData="getSearch" />
                <div class="d-flex gap-2">
                    <button 
                        class="btn bgc-success text-white rounder-8 fw-500"
                        @click="OpenFilters"
                    >
                        <img src="/icons/filter-recomendation.svg" alt="icono" class="me-2" />
                        Filtrar
                    </button>
                    <button
                        class="btn bgc-dark text-white rounder-8 fw-500"
                        @click="exportDataFile"
                    >
                        <img src="/icons/down.svg" alt="icono de tienda" class="me-1" />
                        Exportar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import inputSearch from "../../../../components/inputSearch.vue";
export default {
    name:'filter-polices',
    components:{
        inputSearch
    },
    data(){
        return{
            filter_marca: '',
            filter_other_1: '',
            filter_other_2: 'VIGENTE',
            filter_other_3: '',
            brand: '',
            rule: '',
            search: '',
            search_type: 'codigo',
            select_category: null,
            competitor:'',
            cat_prod: []
        }
    },
    computed: {
        ...mapGetters([
            "authentication_user",
        ]),
    },
    watch: {
        'authentication_user.client_business_select'(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.getData();
            }
        }
    },
    methods:{
        ...mapActions(["get"]),
        /**
         * Builds the API URL with current filter/search parameters and emits it to the parent.
         * @returns {void}
         */
        getData() {
            this.url = `/api/pricescrapingrules/?search=${this.search}&search_type=${this.search_type}&product__prop_extra_1=${encodeURIComponent(this.filter_marca)}&product__prop_extra_5=${encodeURIComponent(this.brand)}&product__prop_extra_2=${this.filter_other_1}&product__prop_extra_3=${this.filter_other_2}&product__prop_extra_4=${encodeURIComponent(this.filter_other_3)}&rule=${this.rule}&client_competitor=${this.competitor}`;
            if (this.select_category != null) {
                this.url = this.url + `&product__categoryproduct=${this.select_category}`
            }
            if (!this.authentication_user.client_channel){
                this.url=this.url+`&product__business=${this.authentication_user.client_business_select}`
            }
            this.$emit('getData', this.url)
        },
        /**
         * Handles search input from the child component and triggers data update.
         * @param {Object} row - Object containing the search string
         * @returns {void}
         */
        getSearch(row) {
            this.search = row.search
            this.search_type = row.searchType
            if (this.authentication_user.groups_user[0].name == 'Category manager'){
                this.getDataByUser();
            }else{
                this.getData()
            }
        },
        getDataByUser(){
            this.get({
                url: `/api/categoryproducts/get_categories_by_user/?user_id=${this.authentication_user.id}`
            }).then((response) => {
                this.cat_prod = response.data.categories
                this.getData()
            })
        },
        /**
         * Emits event to open the filter modal.
         * @returns {void}
         */
        OpenFilters() {
            this.$emit('OpenFilters', 'FilterOptions')
        },
        /**
         * Emits event to trigger data export.
         * @returns {void}
         */
        exportDataFile() {
            this.$emit('exportDataFile')
        }
    }
}
</script>

<style scoped>
.bgc-success{
    background-color: #1AA179 !important;
}
.btn{
    padding: 10px 15px !important;
}
</style>